import { t } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/_forms/bia-messung')({
  component: RouteComponent,

  loader: () => ({
    breadcrumb: {
      label: t`BIA-Messungen`,
      to: '/patienten/$id/bia-messung',
      params: { id: 'patientId' },
    },
  }),
})

function RouteComponent() {
  return <Outlet />
}
